module.exports = __webpack_public_path__ + "static/media/creativeGames.ac0392ee.png";